import { group, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { ResponseStateEnum } from '../discovery-process.enum';
import { DiscoveryWizardBaseCurrentQuestionComponent } from '../discovery-wizard-base-current-question/discovery-wizard-base-current-question.component';
import { DiscoveryChatQuestion, DiscoveryResponse, PossibleResponse } from '../model/discovery-chat.interface';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { animate } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { ClaroComplexMessageComponent, ComplexMessagePartData, ComplexMessagePartType } from 'src/app/moov-common/components/claro-complex-message/claro-complex-message.component';
import { GenderPipe } from 'src/app/moov-common/pipes/gender.pipe';

@Component({
  selector: 'app-discovery-wizard-current-question',
  templateUrl: './discovery-wizard-current-question.component.html',
  styleUrls: ['./discovery-wizard-current-question.component.scss'],
  animations: [
      trigger('slideInOut', [
        state('in', style({
            'opacity': '0.5', 'background-color': '#FA982B'
        })),
        state('out', style({
            'opacity': '1', 'background-color': '#FFFFFF'
        })),
        transition('in => out', [group([
            animate('50ms ease-in-out', style({
              'background-color': '#FFFFFF'
            })),
            animate('50ms ease-in-out', style({
                'opacity': '1'
            }))
        ]
        )]),
        transition('out => in', [group([
            animate('50ms ease-in-out', style({
              'background-color': '#FA982B'
            })),
            animate('50ms ease-in-out', style({
                'opacity': '0.5'
            }))
        ]
        )])
    ]),
  ]
})
export class DiscoveryWizardCurrentQuestionComponent extends DiscoveryWizardBaseCurrentQuestionComponent
  implements OnInit {

  userPosResponseId: string = "";
  userNegResponseId: string = "";
  possibleResponses: ResponseState[] = [];
  reponsesStateMap: Map<string, ResponseStateEnum>;
  state = 'out';
  isQuestionTextAnimationPresented :boolean = false;
  questionsVideoFolder = 'assets/media/questions/';
  currentQuestionVideoAssetName : string = "";
  isVideoMuted : boolean = false;
  @ViewChild('currentQuestionVideo') questionVideo: ElementRef;
  @Input() presentConsultantVideo: boolean = false;
  presentErrorMsg = false;
  errorMessage : ComplexMessagePartData[] = [];

  constructor(private translate: TranslateService, private genderSerivce: GenderPipe) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.userPosResponseId = "";
    this.userNegResponseId = "";
    this.presentErrorMsg = false;
    this.buildResponsesStateArray();
    this.evaluateNextQuestionButton();

    if (this.currentQuestion){
      // const questionVideoName = this.utilsService.buildVideoNameByGenderAndLocale(this.questionsVideoFolder + this.currentQuestion.id, '.mp4', this.user!);
      this.currentQuestionVideoAssetName = this.utilsService.buildVideoNameByGenderAndLocale(this.questionsVideoFolder + this.currentQuestion.id, '.mp4', this.user!);
    }
    else{
      console.log(`DW ngOnInit this.currentQuestion is undefiend`);
    }
  }

  ngAfterViewInit(): void{

    // console.log (`DiscoveryWizardCurrentQuestionComponent ngAfterViewInit ${JSON.stringify(this.questionVideo.nativeElement)}`);
    // this.questionVideo.nativeElement.play();
    this.playVideo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.createErrorMessage();

    if (!changes.currentQuestion){
      return;
    }

    if (changes.currentQuestion.firstChange && this.currentQuestion){
      this.currentQuestionVideoAssetName = this.utilsService.buildVideoNameByGenderAndLocale(this.questionsVideoFolder + this.currentQuestion.id, '.mp4', this.user!);
    }

    if (changes.currentQuestion.currentValue != changes.currentQuestion.previousValue && !changes.currentQuestion.firstChange){
      if (this.currentQuestion !== undefined) {
        // this.focusOnElementOnChat(this.topChat);
        this.nextQuestionAnimation();
        this.userPosResponseId = "";
        this.userNegResponseId = "";
        this.presentErrorMsg = false;
        this.buildResponsesStateArray();
        this.evaluateNextQuestionButton();
        this.playVideo();
          }
      }
      if (changes.presentConsultantVideo && changes.presentConsultantVideo.currentValue != changes.presentConsultantVideo.previousValue && changes.presentConsultantVideo.currentValue ){
        this.playVideo();
      }
    }

    createErrorMessage(): void{
      this.errorMessage = [];

      let messagePart: ComplexMessagePartData = {type:ComplexMessagePartType.TEXT, data:this.translate.instant(this.genderSerivce.transform("discoveryProcess.missingResponsesErrorMsg_1"))}
      this.errorMessage.push(messagePart);

      messagePart = {type:ComplexMessagePartType.ICON, data:'thumb_up', color:POSITIVE_ENABLED_ICON_COLOR}
      this.errorMessage.push(messagePart);

      messagePart = {type:ComplexMessagePartType.TEXT, data:this.translate.instant(this.genderSerivce.transform("discoveryProcess.missingResponsesErrorMsg_2"))}
      this.errorMessage.push(messagePart);

      messagePart = {type:ComplexMessagePartType.ICON, data:'thumb_down', color:NEGATIVE_ENABLED_ICON_COLOR}
      this.errorMessage.push(messagePart);
    }

    playVideo(): void{
      if (!this.presentConsultantVideo || this.currentQuestion == undefined || this.questionVideo == undefined){
        return
      }

      this.currentQuestionVideoAssetName = this.utilsService.buildVideoNameByGenderAndLocale(this.questionsVideoFolder + this.currentQuestion.id, '.mp4', this.user!);
      const media = this.questionVideo.nativeElement;
      if (this.isVideoMuted){
        media.muted = true;
      }
      else{
        media.muted = false;
      }

      media.play();
    }

  buildResponsesStateArray(): void{
    if (!this.currentQuestion){
      return;
    }

    this.possibleResponses = [];

    for (let currPossibleResponse of this.currentQuestion.possibleResponses){
        let responseState = new ResponseState();
        responseState.responseData = currPossibleResponse;

        if (responseState.responseData.id == this.userPosResponseId)
        {
          responseState.state = ResponseStateEnum.Positive;

        }
        else if (responseState.responseData.id == this.userNegResponseId){
          responseState.state = ResponseStateEnum.Negative;
        }
        else{
          responseState.state = ResponseStateEnum.Netural;
        }

        this.possibleResponses = this.possibleResponses.concat(responseState);
    }
  }

  positiveReponseClicked(resId: string): void{
    console.log(`dwcq in positiveReponseClicked resId is ${resId}`);
     // run over all the responses - mark the relevant response, if there are other positive res - make them netural

    if (this.userNegResponseId == resId){
      // The same response was already marked as negative, remove this mark
      this.userNegResponseId = "";
    }

     for (let currResponse of this.possibleResponses){
      if (currResponse.responseData.id == resId){
        currResponse.state = ResponseStateEnum.Positive;
      }
      else if (currResponse.responseData.id != resId && currResponse.state == ResponseStateEnum.Positive){
        currResponse.state = ResponseStateEnum.Netural;
      }

      this.userPosResponseId = resId;
     }

     this.buildResponsesStateArray();
     this.evaluateNextQuestionButton();
  }

  negativeReponseClicked(resId: string): void{
    console.log(`dwcq in negativeReponseClicked resId is ${resId}`);
    // run over all the responses - mark the relevant response, if there are other negative res - make them netural

    if (this.userPosResponseId == resId){
      // The same response was already marked as positive, remove this mark
      this.userPosResponseId = "";
    }

    for (let currResponse of this.possibleResponses){
     if (currResponse.responseData.id == resId){
       currResponse.state = ResponseStateEnum.Negative;
     }
     else if (currResponse.responseData.id != resId && currResponse.state == ResponseStateEnum.Negative){
       currResponse.state = ResponseStateEnum.Netural;
     }

     this.userNegResponseId = resId;
    }

    this.buildResponsesStateArray();
    this.evaluateNextQuestionButton();
 }

 evaluateNextQuestionButton(): void{
  this.isAllResponsesAnswered = false;

  if (this.possibleResponses.length == 0){
    // no possible answers, allow the user to continue
    this.isAllResponsesAnswered = true;
    return;
  }

  if (this.userNegResponseId != "" && this.userPosResponseId != ""){
    this.isAllResponsesAnswered = true;
    this.hideResponsesNumnerError();
  }
 }

 presentResponsesNumnerError(): void{
   this.presentErrorMsg = true;
 }

 hideResponsesNumnerError(): void{
  this.presentErrorMsg = false;
 }

 submitResponse(): void{
    if (!this.isAllResponsesAnswered){
      this.presentResponsesNumnerError();
      return;
    }

    if (!this.currentQuestion){
      this.sendQuestionResponseEvent.emit([]);
      return;
    }

    let responses : DiscoveryResponse[] = [];

    let negativeResponseId: string = "";
    for (let currResponse of this.possibleResponses){
      if (currResponse.responseData.id == this.userNegResponseId){
        // This is the negative reponse id
        negativeResponseId = currResponse.responseData.dependency;
      }
    }

    let posResponse = {questionId:this.currentQuestion.id, responseId:this.userPosResponseId, responseType: ResponseStateEnum.Positive};
    let negResponse = {questionId:this.currentQuestion.id, responseId:negativeResponseId, responseType: ResponseStateEnum.Negative};

    responses= [posResponse, negResponse];
    this.sendQuestionResponseEvent.emit(responses);
 }

 async nextQuestionAnimation() {
  this.state = 'in';
  await this.utilsService.delay(0.2);
  this.state = 'out';
}

muteConsultantVideo() : void{
  this.isVideoMuted = !this.isVideoMuted;

  const media = this.questionVideo.nativeElement;
  if (this.isVideoMuted){
    media.muted = true;
    this.analytics.UserMutedQuestionVideo();
  }
  else{
    media.muted = false;
    this.analytics.UserUnMutedQuestionVideo();
  }
}

}

// As the data source may change states, we want to have the html re-rendered. For this we need to bind a data source that will contain the state of the response - it's less efficient than a map, but we can manage
export class ResponseState{
  responseData: PossibleResponse;
  state: ResponseStateEnum;
}

const POSITIVE_ENABLED_ICON_COLOR = "#4CAF50";
const NEGATIVE_ENABLED_ICON_COLOR = "#F44336";
